import { CommonService } from 'src/app/_Core/_Services/common.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { AdminService } from 'src/app/_Core/_Services/admin.service';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  // formValidator: any;
  fieldErrors: any = [];
  oldPassword: string = '';
  old: boolean;
  showOldPassword: any;
  showConfirmPassword: boolean;
  showNewPassword: any;
  newpass: boolean;
  newPassword: string = '';
  confirmPass: boolean;
  confirmPassword: string = '';
  passOneErr: boolean = false;
  passTwoErr: boolean = false;
  invalidPWD: boolean = false;
  invalidConfirmPWD: boolean = false;
  invalidPasswordMatch: boolean = false;
  newPasswordMinLengthError: boolean = false;
  newConfirmPasswordMinLengthError: boolean = false;
  profileDrawer: boolean = false;
  sucessMsg: boolean = false;

  setPassForm = new FormGroup({
    newPassword: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(8)])
    ),
    confirmPassword: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(8)])
    ),
  });
  invalidOldPWD: boolean;

  constructor(
    private adminSrv: AdminService,
    private adalService: MsAdalAngular6Service,
    private router: Router,private commonService:CommonService
  ) {}
  @HostListener('click', ['$event']) onClick(e) {
    if (
      !e.target.className.includes('dots') &&
      !e.target.className.includes('dot')
    )
      this.profileDrawer = false;
  }
  ngOnInit(): void {}

  toggleOldPassword() {
    this.showOldPassword = !this.showOldPassword;
  }
  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  toggleNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }
  toggle() {
    this.sucessMsg = false;
  }

  enterName(field) {
    if (field == 'oldPassword') {
      this.old = !this.old;
      if (this.oldPassword && this.oldPassword.length > 0) this.old = true;
    }
    if (field == 'newPassword') {
      this.newpass = !this.newpass;
      if (this.newPassword && this.newPassword.length > 0) this.newpass = true;
    }
    if (field == 'confirmPassword') {
      this.confirmPass = !this.confirmPass;
      if (this.confirmPassword && this.confirmPassword.length > 0)
        this.confirmPass = true;
    }
  }

  validatedPwdRegex(field: number) {
    // const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-#^_+=])[A-Za-z\d@$!%*?&\-#^_+=]{8,}$/;
    switch (field) {
      case 1:
        if (!regex.test(this.newPassword)) this.passOneErr = true;
        else this.passOneErr = false;
        break;
      case 2:
        if (!regex.test(this.confirmPassword)) this.passTwoErr = true;
        else this.passTwoErr = false;
        break;
    }
  }

  confirm() {
    const formStatus = this.formValidator();
    if (!formStatus.valid) {
      console.log('Error', formStatus);
      this.fieldErrors = formStatus.errFields;
      console.log('fieldErrors', this.fieldErrors);
      window.scrollTo(0, 0);
      return;
    }
    this.fieldErrors = [];

    if (this.newPassword !== this.confirmPassword) {
      this.invalidPasswordMatch = true;
      return;
    }

    //   if(this.passOneErr)return

    this.adminSrv
      .changePassword({
        password: this.newPassword,
        oldPassword: this.oldPassword,
        token: localStorage.getItem(AppConstant.localStorage.token),
      })
      .subscribe((response) => (this.sucessMsg = response.isValid));
  }

  logout() {
    this.commonService.logoutToken().subscribe((res) => {
      if (res) {
        localStorage.clear();
        if (this.adalService.isAuthenticated == true) {
          this.adalService.logout();
        }
        this.router.navigateByUrl('').then(() => {
          window.location.reload();
        });
      }
    });

  }

  formValidator(): { valid: boolean; errFields: any } {
    const validate = (oldPassword, newPassword, confirmPassword) => {
      let errFields = [];

      if (!oldPassword) {
        const i = errFields.indexOf('oldPwd');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('oldPwd');
      } else {
        const i = errFields.indexOf('oldPwd');
        if (i > -1) errFields.splice(i, 1);
      }
      if (!newPassword) {
        const i = errFields.indexOf('newPwd');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('newPwd');
      } else {
        const i = errFields.indexOf('newPwd');
        if (i > -1) errFields.splice(i, 1);
      }
      if (!confirmPassword) {
        const i = errFields.indexOf('confirmPwd');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('confirmPwd');
      } else {
        const i = errFields.indexOf('confirmPwd');
        if (i > -1) errFields.splice(i, 1);
      }

      if (errFields.length > 0) return { valid: false, errFields: errFields };
      else return { valid: true, errFields: [] };
    };

    return validate(this.oldPassword, this.newPassword, this.confirmPassword);
  }
  inputModelChange() {
    const formStatus = this.formValidator();
    this.fieldErrors = [];
    if (!formStatus.valid) this.fieldErrors = formStatus.errFields;
    return;
  }

}
